module.exports = __webpack_public_path__ + "img/undraw_setup_analytics_8qkl.cbc7d9f8.svg";